import { Button } from "react-bootstrap";
import { TypeHelper } from "../../../helpers/TypeHelper";
import { DocumentListViewToolbar } from "./DocumentListViewToolbar";
import { ListViewToolbarButton } from "./ListViewToolbarButton";
import React from "react";
import { useTranslation } from "react-i18next";

interface IProps {
  onCreateNewClick?: () => void;
  onCloneClick?: () => void;
  onEditClick?: () => void;
  onShowTransactionsPage?: () => void;
  children?: React.ReactNode;
  onDeleteClick?: () => void;
  onShowPopup?: () => void;
  entity?: any;
  onPostClick?: () => void;
  onCancelClick?: () => void;
  selectedItemId?: string | undefined;
  selectedItem?: boolean | undefined;
  handleCreateDocumentAction?: () => void;
  createDocumentActions?: any;
  viewType?: string;
  handleCreateNewFolder?: () => void;
  handleSwitchViewType?: () => void;
}

export const CatalogListViewDefaultToolbarButtons = ({
  children,
  onDeleteClick,
  entity,
  selectedItemId,
  onCreateNewClick,
  onCloneClick,
  onEditClick,
  viewType,
  handleSwitchViewType,
  handleCreateNewFolder
}: IProps) => {
  const { t } = useTranslation();
  const arrayChildren = React.Children.toArray(children);

  return (
    <>
      <Button size={"sm"} variant="" className="btn btn-primary mb-3 me-2" onClick={onCreateNewClick}>
        Add New
      </Button>
      {viewType === "tree" && (
        <Button size={"sm"} variant="" className="btn btn-primary mb-3 me-2" onClick={handleCreateNewFolder}>
          Add New Folder
        </Button>
      )}
      {entity.isHierarchy && (
        <Button className="btn btn-primary mb-3 me-2" onClick={handleSwitchViewType} size={"sm"}>
          Tree/List
        </Button>
      )}
      <div className={"flex-grow-1"}></div>
      <ListViewToolbarButton disabled={!selectedItemId} caption={t("Clone")} onClick={onCloneClick} extraClass={"btn btn-light mb-3 me-2"} iconClass={"fa-solid fa-clone"} />
      <ListViewToolbarButton disabled={!selectedItemId} caption={t("Edit")} onClick={onEditClick} extraClass="btn btn-light mb-3 me-2" iconClass={"fa-solid fa-pen-to-square"} />
      <ListViewToolbarButton disabled={!selectedItemId} caption={t("Delete")} onClick={onDeleteClick} extraClass="btn btn-light mb-3 me-2" iconClass={"fa-solid fa-trash me-2"} />
    </>
  );
};
//
